function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0L36 36L0 36L0 0Z",
  id: "shield_path"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "shield_mask"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#shield_path"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "shield-(2)-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0L36 36L0 36L0 0Z",
  id: "shield-(2)-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shield_mask)"
}, /*#__PURE__*/React.createElement("g", {
  id: "surface1",
  transform: "translate(2.7421875 0.00012207031)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.6874 30.8172C22.503 32.9502 19.6427 34.6451 16.1859 35.8542C16.0725 35.8937 15.9541 35.9261 15.8351 35.95C15.678 35.9811 15.5182 35.9978 15.3597 36L15.3287 36C15.1598 36 14.99 35.983 14.8217 35.95C14.7027 35.9261 14.586 35.8937 14.4731 35.855C11.0121 34.6479 8.14828 32.9538 5.96173 30.8208C4.04186 28.9468 2.57876 26.6679 1.61251 24.0455C-0.14448 19.2774 -0.0445046 14.0249 0.0359703 9.80391L0.0373436 9.73909C0.0535484 9.39055 0.0639854 9.02443 0.0697533 8.62013C0.0991417 6.63518 1.67733 4.993 3.66256 4.88231C7.80166 4.65132 11.0036 3.30137 13.7395 0.634716L13.7634 0.612744C14.2177 0.196087 14.7901 -0.00825901 15.3597 0.000255439C15.909 0.00739657 16.4562 0.211468 16.8942 0.612744L16.9176 0.634716C19.654 3.30137 22.856 4.65132 26.9951 4.88231C28.9803 4.993 30.5585 6.63518 30.5879 8.62013C30.5936 9.02718 30.6041 9.39275 30.6203 9.73909L30.6211 9.76656C30.7013 13.9955 30.8007 19.2585 29.0374 24.0406C28.0698 26.663 26.6064 28.9432 24.6874 30.8172Z",
  id: "Vector",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.32767 30.8169C7.14331 32.9499 4.28302 34.6449 0.826172 35.8539C0.712738 35.8935 0.59436 35.9259 0.475433 35.9498C0.318329 35.9808 0.158478 35.9976 0 35.9998L0 0C0.549317 0.00714114 1.09644 0.211212 1.53452 0.612488L1.55786 0.634461C4.29428 3.30112 7.49625 4.65107 11.6353 4.88205C13.6206 4.99274 15.1988 6.63492 15.2282 8.61988C15.2339 9.02692 15.2444 9.39249 15.2606 9.73884L15.2614 9.7663C15.3416 13.9952 15.441 19.2582 13.6777 24.0403C12.7101 26.6627 11.2467 28.943 9.32767 30.8169Z",
  transform: "translate(15.360352 0.0008544922)",
  id: "Vector",
  fill: "#2F42B0",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.00385 17.9443L8.97227 17.9443C4.02539 17.9443 0 13.9191 0 8.97199C0 4.02512 4.02539 0 8.97227 0L9.00385 0C13.9362 0.0175781 17.9443 4.03583 17.9443 8.97199C17.9443 13.9084 13.9362 17.9267 9.00385 17.9443Z",
  transform: "translate(6.3554688 9.027954)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 17.9443L0 0C4.93232 0.0175781 8.94041 4.03583 8.94041 8.97199C8.94041 13.9084 4.93232 17.9267 0 17.9443Z",
  transform: "translate(15.360352 9.027954)",
  id: "Vector",
  fill: "#E1EBF0",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 5.84452L0 2.85652L2.54718 0.309609C2.95972 -0.103203 3.62879 -0.103203 4.04078 0.309609C4.45331 0.722145 4.45331 1.39121 4.04078 1.8032L0 5.84452Z",
  transform: "translate(15.360352 14.904785)",
  id: "Vector",
  fill: "#6FA5AA",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.55425 5.84452L3.68111 6.71766C3.47484 6.92393 3.2043 7.02693 2.93404 7.02693C2.6635 7.02693 2.39324 6.92393 2.18669 6.71766L0.309403 4.83955C-0.103134 4.42701 -0.103134 3.75877 0.309403 3.34596C0.72139 2.93342 1.39046 2.93342 1.803 3.34596L2.93404 4.477L7.10143 0.309609C7.51397 -0.103203 8.18303 -0.103203 8.59502 0.309609C9.00756 0.722145 9.00756 1.39121 8.59502 1.8032L4.55425 5.84452Z",
  transform: "translate(10.805664 14.904785)",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgShield = function SvgShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield.56892b11.svg";
export { ForwardRef as ReactComponent };